module.exports = __webpack_public_path__ + "img/3.417cdb93.gif";